import { render } from "./Producers.vue?vue&type=template&id=126706f5"
import script from "./Producers.vue?vue&type=script&lang=js"
export * from "./Producers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__